<template>
    <div class="shadow-off pt-2 pb-0 pl-0 pr-0">
        <div>
            <div class="d-flex align-center justify-end mb-4 mt-4">
                <v-btn data-testid="transaction-matching-config-new__create-filter-button" color="" class="secondaryBtn" @click="$emit('addfilterbox')">
                    <v-icon data-testid="transaction-matching-config-new__create-filter-icon" class="mr-1">mdi-plus</v-icon>
                    <span>Create Filter</span>
                </v-btn>
                <v-btn data-testid="transaction-matching-config-new__save-filter-button" color="primary" class=" ml-2" @click="$emit('save-order')" v-if="formatedData.length > 0">
                    <span>Save</span>
                </v-btn>
            </div>
            <v-card class="shadow-off">
                <v-card-text data-testid="transaction-matching-config-new__filter-table" class="pa-0 shadow-off" v-if="formatedData.length > 0">
                    <v-simple-table class=" border-on">
                        <template v-slot:default>
                            <thead class="tableHeaderBg">
                                <tr class="tableHeaderBg">
                                    <th data-testid="transaction-matching-config-new__filter-header" v-for="(header, index) in headers" :key="index" class="tableHeaderBg" :id="'automation-test-'+ index">
                                        {{header.text }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr data-testid="transaction-matching-config-new__filter-row" v-for="(item, i) in formatedData" :id="'automation-test-'+ i" :key="i" draggable="true" @dragstart="onDragStart(i)" @dragover.prevent @drop="onDropFilter(i)" @dragend="onDragEnd">
                                    <td>{{ item.indexno + 1 }}</td>
                                    <td>{{ item.tag }}</td>
                                    <td>{{ item.description }}</td>
                                    <td>{{ item.operator }}</td>
                                    <td>{{ gettableName(item.tableid) }}</td>
                                    <td>{{ item.column }}</td>
                                    <td>{{ item.filterword }}</td>
                                    <td>
                                        <div class="d-flex">
                                            <v-tooltip bottom content-class="tooltip-bottom">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn data-testid="transaction-matching-config-new__filter-drag-button" icon v-bind="attrs" v-on="on" class="cursor-drag">
                                                        <v-icon data-testid="transaction-matching-config-new__filter-drag-icon"> mdi-drag </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Drag-Drop</span>
                                            </v-tooltip>
                                            <v-tooltip bottom content-class="tooltip-bottom">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn data-testid="transaction-matching-config-new__filter-edit-button" icon v-bind="attrs" v-on="on" @click.stop="$emit('editfilterboxPush', item)">
                                                        <v-icon data-testid="transaction-matching-config-new__filter-edit-icon">mdi-pencil</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Edit</span>
                                            </v-tooltip>
                                            <v-tooltip bottom content-class="tooltip-bottom">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn data-testid="transaction-matching-config-new__filter-delete-button" icon v-bind="attrs" v-on="on" @click.stop="$emit('deletefilterboxPush', item)">
                                                        <v-icon data-testid="transaction-matching-config-new__filter-delete-icon">mdi-delete</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Delete</span>
                                            </v-tooltip>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>
                <v-card-text v-else>
                    <div data-testid="transaction-matching-config-new__filter-empty-state" class="text-center grey--text title pa-6"> No Filter available </div>
                </v-card-text>
            </v-card>
        </div>
        <div class="mt-4">
            <v-btn data-testid="transaction-matching-config-new__step2-back-button" color="secondaryBtn" class="mr-1" @click="$emit('back')"><span>Back</span></v-btn>
            <v-btn data-testid="transaction-matching-config-new__step2-continue-button" color="primary" @click="$emit('continue')" class="mr-1"><span>Continue</span></v-btn>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'StepFilterConfig',
        props: {
            formatedData: Array,
            headers: Array,
            setupList: Object // Needed for gettableName
        },
        data() {
            return {
                draggedItemIndex: null
            }
        },
        methods: {
            gettableName(id) {
                if (this.setupList && this.setupList.file) {
                    let file = this.setupList.file.find(f => f._id === id);
                    return file ? file.name : '';
                }
                return '';
            },
            onDragStart(index) {
                this.draggedItemIndex = index;
            },
            onDropFilter(index) {
                this.$emit('reorder-filters', {
                    from: this.draggedItemIndex,
                    to: index
                });
                this.draggedItemIndex = null;
            },
            onDragEnd() {
                this.draggedItemIndex = null;
            }
        }
    }
</script>